import { render, staticRenderFns } from "./DropzoneField.vue?vue&type=template&id=58c2b5c5"
import script from "./DropzoneField.vue?vue&type=script&lang=js"
export * from "./DropzoneField.vue?vue&type=script&lang=js"
import style0 from "./DropzoneField.vue?vue&type=style&index=0&id=58c2b5c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports